import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../app/modals/redux/modalActions';
import ModalTesLeavePageButtonBack from './MTesLeavePageButtonBack';
import ShieldHalfFull from '../../../app/common/icons/ShieldHalfFull';
import ExitRun from '../../../app/common/icons/ExitRun';
import MBody from './MBody';

const actions = {
  closeModal,
};

function ModalTesLeavePage(props) {
  const { closeModal } = props;
  const [run, setRun] = useState(false);

  const logChange = () => {
    if (document.visibilityState === 'visible' || !document.hidden) {
      setRun(true);
      return;
    }
  };

  const checkFocus = () => {
    setRun(true);
  };

  const checkBlur = () => {
    setRun(false);
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', logChange);
    window.addEventListener('focus', checkFocus, false);
    window.addEventListener('blur', checkBlur, false);
    return () => {
      document.removeEventListener('visibilitychange', logChange);
      window.removeEventListener('focus', checkFocus, false);
      window.removeEventListener('blur', checkBlur, false);
    };
  }, []);

  const onClose = () => {
    closeModal();
  };

  return (
    <MBody>
      <p className='mt-5'>
        <ExitRun size={64} color={'#f24667'} />
      </p>
      <p className='mt-2'>
        <span className='tag is-danger is-medium is-rounded'>
          <ShieldHalfFull size={15} color={'#ffffff'} />
          <span className='ml-1'>Ujian Sedang Berlangsung</span>
        </span>
      </p>
      <p className='mt-1'>Kamu terdeteksi meninggalkan halaman ujian.</p>{' '}
      <p className='is-size-7 is-italic' style={{ width: 320, margin: 'auto' }}>
        Note: Jawaban yang belum disubmit akan hilang jika kamu menutup halaman
        ujian!
      </p>
      <div className='mt-4 flex justify-center' style={{ gap: 10 }}>
        <ModalTesLeavePageButtonBack onClose={onClose} run={run} />
      </div>
    </MBody>
  );
}

export default connect(null, actions)(ModalTesLeavePage);
